module.exports = __webpack_public_path__ + "static/coca_recruitment-d09c279f9caaace38e49a6ae1b6adb61.jpeg";